import React, { type ReactNode } from 'react';
import Heading from '@atlaskit/heading';
import { Inline, Stack, xcss } from '@atlaskit/primitives';
import { useIntl } from '@atlassian/jira-intl';
import { BackButton } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-back-button/src/ui/back-button/index.tsx';
import { MenuList, SideNavHeader, SideNavContent } from '@atlassian/navigation-system';
import { AsyncPageSwitcher } from '../../common/ui/page-switcher/index.tsx';
import type { PageName } from '../../common/ui/page-switcher/types.tsx';
import messages from './messages.tsx';

type Props = {
	children: ReactNode;
	currentPageName: PageName;
	testId?: string;
};

export const SidebarContent = ({
	children,
	currentPageName,
	testId = 'navigation-apps-sidebar-nav4-sidebars-settings-global-common.ui.sidebar-content',
}: Props) => {
	const { formatMessage } = useIntl();

	return (
		<>
			<SideNavHeader>
				<Stack space="space.200" xcss={headingStyles}>
					<Inline
						alignBlock="center"
						grow="hug"
						space="space.100"
						testId="navigation-apps-sidebar-nav4-sidebars-settings-global-common.ui.sidebar-content.header"
					>
						<BackButton />
						<Heading size="small" as="h2">
							{formatMessage(messages.heading)}
						</Heading>
					</Inline>

					<AsyncPageSwitcher currentPageName={currentPageName} />
				</Stack>
			</SideNavHeader>

			<SideNavContent testId={testId}>
				<MenuList>{children}</MenuList>
			</SideNavContent>
		</>
	);
};

const headingStyles = xcss({
	// 4px of left padding is added to align the back icon with the side nav toggle button
	paddingInlineStart: 'space.050',
});
